var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_347_1227",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 33
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0083 16.1718L18.3697 1.7387L17.4555 0.77076C17.2472 0.551672 16.9655 0.428711 16.6719 0.428711C16.3783 0.428711 16.0966 0.551672 15.8884 0.77076L1.3356 16.1718C1.12216 16.3969 0.953481 16.665 0.839511 16.9603C0.725541 17.2555 0.66859 17.572 0.672021 17.8909C0.68614 19.2064 1.72033 20.2566 2.96277 20.2566H4.46287V32.4287H28.881V20.2566H30.4129C31.0164 20.2566 31.5847 20.0062 32.0118 19.554C32.2221 19.3321 32.3887 19.0681 32.502 18.7775C32.6153 18.4869 32.673 18.1754 32.6719 17.861C32.6719 17.2257 32.4354 16.624 32.0083 16.1718ZM18.6485 29.7379H14.6953V22.114H18.6485V29.7379ZM26.3397 17.5658V29.7379H20.9075V21.2171C20.9075 20.3911 20.2757 19.7222 19.4957 19.7222H13.8482C13.0682 19.7222 12.4364 20.3911 12.4364 21.2171V29.7379H7.00422V17.5658H3.61575L16.6755 3.74932L17.4908 4.61262L29.7317 17.5658H26.3397Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_347_1227)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.671875,
    y: 0.428711,
    width: 32,
    height: 32,
    fill: "black"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.19f631232a39761380b601489131df21.svg";
export { ForwardRef as ReactComponent };